import React from 'react'

import { cn } from '@/lib/utils'

import { StylesProps } from '../page-header.types'
import { HeaderBanner } from '../shared/header-banner'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const GeexDoctorPageHeader = ({
  page,
  hasLogoImage,
  hasName,
  hasDescription,
  hasIcons,
  forceMobile,
  ...props
}: StylesProps) => {
  return (
    <div className={cn({ 'lg:pt-fluid-10': !forceMobile })}>
      <HeaderBanner
        media={page?.bannerMedia}
        className="h-fluid-96"
        {...props}
        style={{
          maskImage: `linear-gradient(black, black),url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzc1IiBoZWlnaHQ9IjI2IiB2aWV3Qm94PSIwIDAgMzc1IDI2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMCAyMEMwIDguOTU0MzEgOC45NTQzMSAwIDIwIDBIMzU1QzM2Ni4wNDYgMCAzNzUgOC45NTQzMSAzNzUgMjBWMjZIMFYyMFoiIGZpbGw9IiNEOUQ5RDkiLz4KPC9zdmc+Cg==')`,
          maskRepeat: 'no-repeat',
          maskPosition: 'center calc(100% + 1px)',
          maskSize: '100% auto',
          maskComposite: 'exclude',
          WebkitMaskImage: `linear-gradient(black, black),url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzc1IiBoZWlnaHQ9IjI2IiB2aWV3Qm94PSIwIDAgMzc1IDI2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMCAyMEMwIDguOTU0MzEgOC45NTQzMSAwIDIwIDBIMzU1QzM2Ni4wNDYgMCAzNzUgOC45NTQzMSAzNzUgMjBWMjZIMFYyMFoiIGZpbGw9IiNEOUQ5RDkiLz4KPC9zdmc+Cg==')`,
          WebkitMaskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center calc(100% + 1px)',
          WebkitMaskSize: '100% auto',
          WebkitMaskComposite: 'exclude',
        }}
      />

      {(hasLogoImage || hasName || hasDescription || hasIcons) && (
        <div className="-mt-fluid-6 p-fluid-4">
          <div className="ft-widget page-header-block ft-widget-wrapper flex flex-col space-y-fluid-4 p-fluid-5 py-fluid-6">
            <div className="relative flex flex-row space-x-fluid-6">
              <HeaderLogo
                media={page?.logoMedia}
                {...props}
                className="min-w-fluid-16 rounded-[6px]"
                sizeClassName="size-fluid-16"
                size={64}
              />

              <div className="flex flex-col space-y-fluid-1">
                <HeaderName
                  name={page?.name}
                  {...props}
                  className="text-fluid-3xl text-page-heading-text"
                />

                <HeaderDescription
                  description={page?.description}
                  {...props}
                  className="text-fluid-lg"
                />
              </div>
            </div>

            <HeaderSocialIcons
              socialIcons={page?.socialIcons}
              {...props}
              className="mt-fluid-4"
              primaryClassName="p-fluid-3 page-header-primary-button flex-1"
              secondaryClassName="p-fluid-3 page-header-secondary-button"
              showPrimaryLabel
            />
          </div>
        </div>
      )}
    </div>
  )
}
